import {gql} from '@apollo/client'

export const CREATE_FOLDER = gql`
  mutation CreateFolder($input: FolderInput!) {
    createFolder(input: $input) {
      id
      name
      parentId
      createdAt
      updatedAt
    }
  }
`

export const RENAME_FOLDER = gql`
  mutation RenameFolder($input: RenameInput!) {
    renameFolder(input: $input)
  }
`
